import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { RouterProvider, useParams } from 'react-router-dom';
import { ErrorPage } from './views/ErrorPage.tsx';
import { ParamsSetup } from './views/ParamsSetup.tsx';
import { RoomsPage } from './views/Rooms/RoomsPage.tsx';
import { RoomDetails } from './Room/RoomDetails.tsx';
import { Checkout } from './Checkout.tsx';
import { Rates } from './views/Rates/Rates.tsx';
import { AuthPage } from './views/AuthPage/AuthPage.tsx';
import { ProtectedRoute } from './components/ProtectedRoute.tsx';
import { UserForm } from './views/Rates/UserForm.tsx';
import { AuthWelcome } from './views/AuthPage/WelcomePage.tsx';
import { Account } from './views/Account/Account.tsx';
import { BookingInfo } from './views/Account/BookingItem/BookingInfo.tsx';
import { BookingList } from './views/Account/BookingList.tsx';
import { Profile } from './views/Account/ProfileTab/ProfileTab.tsx';
import './initSentry.ts';
import { sentryCreateBrowserRouter } from './initSentry.ts';
import { ServicesPage } from './views/Services/Services.tsx';
import { AddServices } from './views/Account/BookingItem/AddServices.tsx';
import { BookingItem } from './views/Account/BookingItem/BookingItem.tsx';
import { EditBooking } from './views/Account/BookingItem/EditBooking.tsx';
import { BookingHistory } from './views/Account/BookingItem/BookingHistory.tsx';

const OnSuccess = () => {
  const urlParams = useParams();
  useEffect(() => {
    console.log(urlParams);
  }, []);
  return <p>onSuccess</p>;
};

const router = sentryCreateBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <ParamsSetup />
          </ProtectedRoute>
        ),
      },
      {
        path: 'account',
        element: (
          // <ProtectedRoute>
          <Account />
          // </ProtectedRoute>
        ),
        children: [
          { index: true, element: <BookingList /> },
          { path: 'info', element: <Profile /> },
        ],
      },
      {
        path: '/booking-list/:bookingId',
        element: <BookingItem />,
        children: [
          {
            index: true,
            element: <BookingInfo />,
          },
          {
            path: 'add-services',
            element: <AddServices />,
          },
          {
            path: 'edit',
            element: <EditBooking />,
            children: [
              {
                path: ':roomId?/details',
                element: <RoomDetails />,
              },
            ],
          },
          {
            path: 'history',
            element: <BookingHistory />,
          },
        ],
      },
      {
        path: '/api/v1/users/login-sber-id',
        element: <OnSuccess />,
      },
      {
        path: '/welcome',
        element: <AuthWelcome />,
      },
      {
        path: '/auth',
        element: <AuthPage />,
      },
      {
        path: 'rooms/:roomId?/*',
        element: (
          <ProtectedRoute>
            <RoomsPage />
          </ProtectedRoute>
        ),
        children: [
          {
            path: 'details',
            element: <RoomDetails />,
          },
        ],
      },
      {
        path: '/rates',
        element: (
          <ProtectedRoute>
            <Rates />
          </ProtectedRoute>
        ),
      },
      {
        path: '/services',
        element: (
          <ProtectedRoute>
            <ServicesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/form',
        element: (
          <ProtectedRoute>
            <UserForm />
          </ProtectedRoute>
        ),
      },
      {
        path: 'checkout/:roomId',
        element: <Checkout />,
      },
    ],
  },
  {
    path: 'about/:id?',
    element: <div>This is about page</div>,
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
